import React, {useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import CardMedia from '@material-ui/core/CardMedia'
import CircularProgress from "@material-ui/core/CircularProgress";

import ConfirmDialog from './ConfirmDialog.js';

import google_button from './btn_google_signin_dark_normal_web.png';
//import { Snackbar } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
        padding: 20,
        paddingTop:100,
        margin: 'auto',
      maxWidth: 800,
    },
    formCard: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
          //margin: theme.spacing(2),
          alignItems: 'center',
      }, 
      button: {
           padding: theme.spacing(1),
        margin: theme.spacing(1),
          alignItems: 'center',
          //width: 150,
      },
      cardContent: {
          paddingTop: theme.spacing(1),
          paddintBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      cardAction: {
        justifyContent: 'center',  
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionForm: {
        justifyContent: 'left', 
        //display:'flex',
        //flexGrow:1, 
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionButton: {
        justifyContent: 'center',  
         paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      media: {
          //width: 100,
          //marginBottom: theme.spacing(4),
      },
      textField: {
          //textAlign: 'right',
          //marginRight:theme.spacing(1),
      },
      textForm: {
        textAlign: "left",
        //flexGrow: 1,
        //marginLeft:theme.spacing(1),
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      text: {
        textAlign: "center",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textExplanation: {
        textAlign: "justify",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      select: {
        minWidth: 250,
      }
  }));

  export default function ConfirmLoginState (props) {
    const classes = useStyles();
    const [privacyOpen, setPrivacyOpen] = useState(false); // privacy dialog boolean

    function handlePrivacyOpen() {
        setPrivacyOpen(true);
      }
    
      function handlePrivacyAgreeClose () { // If pt agrees to privacy, allow to move forward to app
        setPrivacyOpen(false);
        props.onSignIn();
      }
  
      function handlePrivacyDisagreeClose () { //If pt does not agree to privacy, send back to main screen
        setPrivacyOpen(false);
      }
  

      function confirmLoginState() {
        if (props.loading) {
            return <>
                <CardContent className={classes.card}>
                    <Typography variant="h6" color="inherit"><CircularProgress /></Typography>
                </CardContent>
            </>;
        } else if (props.error) {
            return <>
                <CardContent className={classes.cardContent}>
                    <Typography variant="h6" color="inherit">Error: {props.error.message}</Typography>
                </CardContent>
                <CardActions className={classes.cardAction}>        
                    <Button className={classes.button} size="medium" variant="contained" color="primary" onClick={handlePrivacyOpen}><CardMedia className={classes.media} image={google_button} component="img" alt="google sign-in"/></Button>
                </CardActions>
            </>;
        } else if (props.user) {
        return <>
                <CardContent className={classes.cardContent}>
                    {props.displayFragment} 
                </CardContent>
                <CardContent className={classes.cardContent}>
                    <Typography className={classes.textExplanation} color="inherit">Logged in as {props.user.email}. <Link onClick={props.onSignOut} color="secondary">Log out</Link>.</Typography>
                </CardContent>
             </>;
        }
        return <>
                <CardContent className={classes.cardContent}>
                    <Typography className={classes.textExplanation} color="inherit">{props.explanationText}</Typography>
                </CardContent>
                <CardActions className={classes.cardActionButton}>        
                    <Button className={classes.button} size="medium" variant="contained" color="primary" onClick={handlePrivacyOpen}><CardMedia className={classes.media} image={google_button} component="img" alt="google sign-in"/></Button>
                </CardActions>
    </> ;
    }

    return <>
    {confirmLoginState()}
    <ConfirmDialog title={"Privacy Disclaimer"} description={<React.Fragment>Login via Google is only required for the <strong>log</strong> apps.  It is used to track history of results necessary for functionality. If you agree to sign in by Google, relevant data will be stored in Google Firestore Cloud. Note that this data is  subject to the same level of security as your general Google account data. By continuing, you acknowledge understanding and acceptance of the privacy disclaimer and <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">policy.</Link></React.Fragment>} agree="Agree & Continue" disagree={"Return"} open={privacyOpen} onCloseClick={handlePrivacyDisagreeClose} onAgreeClick={handlePrivacyAgreeClose}/>
    </>;
  } 

  /* <Snackbar open={props.user} message="You are logged in." action={<Button variant="contained" color="primary">X</Button>}  autoHideDuration={60}/>*/
  // Snackbar open={props.user} message="You are logged in." />
